module.exports = __webpack_public_path__ + "static/media/header_showcase.4d7247b2.svg";